import { FC } from 'react'

import styled from 'styled-components'

import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'
import TikTokIcon from 'src/Assets/Svg/platform-icons/TikTok.svg?react'
import SpotifyIcon from 'src/Assets/Svg/platform-icons/Spotify.svg?react'
import { CampaignPlatformTypeEnum } from 'src/Types'

import { SquareButton, SquareButtonProps } from '../SquareButton'

const StyledButton = styled(SquareButton)`
  padding: 7px;

  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    flex-grow: 0;
  }
`

export type PlatformButtonProps = Pick<
  SquareButtonProps,
  'loading' | 'onClick' | 'className' | 'disabled'
> & {
  platform: CampaignPlatformTypeEnum
}

export const PlatformButton: FC<PlatformButtonProps> = ({
  platform,
  className,
  loading,
  onClick,
  disabled,
}) => {
  const Icon =
    platform === CampaignPlatformTypeEnum.TIKTOK ? TikTokIcon : SpotifyIcon

  return (
    <StyledButton
      className={className}
      loading={loading}
      onClick={onClick}
      disabled={disabled}
    >
      <Icon />
    </StyledButton>
  )
}
